import Model, { AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';

import type RoomControlConfigurationModel from 'admin-panel/models/room-control/configuration';
import type RoomControlTvChannelModel from 'admin-panel/models/room-control/tv-channel';

export default class RoomControlConfigTvChannelModel extends Model {
  @belongsTo('room-control/configuration')
  declare roomControlConfiguration: AsyncBelongsTo<RoomControlConfigurationModel>;

  @belongsTo('room-control/tv-channel')
  declare roomControlTvChannel: AsyncBelongsTo<RoomControlTvChannelModel>;

  @attr
  declare value: string;

  @attr
  declare position: number;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/config-tv-channel': RoomControlConfigTvChannelModel;
  }
}
